import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import Modal from 'react-modal';
import { connect } from 'react-redux';

import { setLoading } from '../actions/authAction';
import history from '../history';
import Login from './pages/Login';
import AutoLogin from './pages/AutoLogin';
import Home from './pages/Home';
import Authorize from './pages/Authorize';
import Query from './pages/Query';
import Release from './pages/Release';
import ManageRelease from './pages/ManageRelease';
import ManageDoa from './pages/ManageDoa';
import UploadDoa from './pages/UploadDoa';
// import CheckoutDoa from './pages/CheckoutDoa';
import Group from './pages/Group';
import GroupDetail from './pages/GroupDetail';
import SearchRequest from './pages/SearchRequest';
import SearchRequestForAdmin from './pages/SearchRequestForAdmin';
import Configuration from './pages/Configuration';
import UploadDoaNewBook from './pages/UploadDoaNewBook';
import UploadEmployee from './pages/UploadEmployee';
import UploadUser from './pages/UploadUser';
import UploadOrganization from './pages/UploadOrganization';
import GenerateTagBr from './pages/GenerateTagBr';

const customStylesLoading = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: '#f9f9f9',
        padding: '0',
        border: 'none',
        borderRadius: '25px',
        zIndex: '999'
    }
};

Modal.setAppElement('#root')

const App = ({ isLoading }) => {
    return (
        <div>
            <HashRouter history={history}>
                <div className="app">
                    <Switch>
                        <Route path="/" exact component={Login} />
                        <Route path="/Local" exact component={Login} />
                        <Route path="/Encodetext" exact component={GenerateTagBr} />
                        <Route path="/home/:userId" exact component={Home} />
                        <Route path="/authorize/:userId" exact component={Authorize} />
                        <Route path="/query/:userId" exact component={Query} />
                        <Route path="/ManageDoa/:userId" exact component={ManageDoa} />
                        <Route path="/Permission/Group" exact component={Group} />
                        <Route path="/Permission/GroupDetail/:groupId" exact component={GroupDetail} />
                        {/* <Route path="/Upload/Doa" exact component={UploadDoa} /> */}
                        <Route path="/Upload/Doa/:id?" exact component={UploadDoa} />
                        {/* <Route path="/Checkout/Doa" exact component={CheckoutDoa} /> */}
                        <Route path="/Configuration" exact component={Configuration} />
                        <Route path="/Upload/AllinBook" exact component={UploadDoaNewBook} />
                        <Route path="/Upload/Organization" exact component={UploadOrganization} />
                        <Route path="/Upload/User" exact component={UploadUser} />
                        <Route path="/Upload/Employee" exact component={UploadEmployee} />
                        <Route path="/Search/All" exact component={SearchRequestForAdmin} />
                        <Route path="/Search/Request/:type" exact component={SearchRequest} />
                        <Route path="/Search/Request/:type/:id" exact component={SearchRequest} />
                        <Route path="/settings/release" exact component={Release} />
                        <Route path="/settings/release/:bookCode" exact component={ManageRelease} />
                        <Route path="/AutoLogin/jwt" exact component={AutoLogin} />
                    </Switch>
                </div>
            </HashRouter>
            <Modal
                isOpen={isLoading}
                style={customStylesLoading}
                contentLabel="Loading"
            >
                <div className="flex-v flex-center p-16 m-24">
                    <div className="spinner mb-8 mt-8">
                        <div className="bounce1 dark"></div>
                        <div className="bounce2 dark"></div>
                        <div className="bounce3 dark"></div>
                    </div>
                    <h2 className="text-bold" style={{ opacity: '0.7' }}>Loading</h2>
                </div>
            </Modal>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.auth.isLoading
    }
}

export default connect(mapStateToProps, {
    setLoading
})(App);